export const timeMixin = {
    methods: {
      getCurrentTime() {
        const currentDate = new Date()
        const year = currentDate.getFullYear();
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
        const day = currentDate.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
    }
  };
  


// WEBPACK FOOTER //
// ./src/lib/timeMixin.js